var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmplify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/48/Arch_AWS-Amplify_48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dd344c",
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.637 47.677 32.333 17h3.794L50.43 47.677zm6.27.578L37.67 15.577a1 1 0 0 0-.906-.577h-6a1 1 0 0 0-.906 1.422l15.236 32.677a1 1 0 0 0 .906.578h6a1 1 0 0 0 .907-1.422m-16.277-.578-10.536-22.03 2.325-3.846 12.015 25.876zm-7.187-28.422a1 1 0 0 0-.853-.578.96.96 0 0 0-.91.481l-3.576 5.915a1 1 0 0 0-.047.95l11.04 23.086c.167.347.519.568.903.568h6a1 1 0 0 0 .908-1.421zm-16.67 28.422 9.639-15.94 1.619 3.236-4.782 8.102a1 1 0 0 0 .862 1.508h8.704l1.56 3.094zm17.55-4.544a1 1 0 0 0-.893-.55h-7.568l4.168-7.062c.17-.292.184-.652.033-.955l-2.673-5.347a1 1 0 0 0-.855-.552.99.99 0 0 0-.895.482l-11.495 19.01A1 1 0 0 0 11 49.677h21a1 1 0 0 0 .893-1.451z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmplify);
export default __webpack_public_path__ + "static/media/amplify.f8e2be1a68853dd8f7e757dd85f9287e.svg";
export { ForwardRef as ReactComponent };